import { createSelector } from "reselect";

import { RootState } from "../../store/types";
import { LayoutChoiceState } from "./reducer";

export const step3 = (state: RootState): LayoutChoiceState =>
  state.wizardLayoutChoice;

export const layouts = createSelector(step3, state => state.layouts);
export const isLayoutsLoading = createSelector(
  step3,
  state => state.isLayoutsLoading,
);
export const chosenLayout = createSelector(step3, state => state.chosenLayout);
export const chosenLayoutIndex = createSelector(
  chosenLayout,
  layouts,
  (chosenLayout, layouts) => {
    if (!chosenLayout) {
      return 0;
    }

    const index = layouts.findIndex(curr => curr.id === chosenLayout.id);
    return index !== -1 ? index : 0;
  },
);



// WEBPACK FOOTER //
// ./src/routes/WizardLayoutChoice/selectors.ts